import React, { useState } from "react";
import axios from "axios";

function TestAPI() {
    const [apiURL, setApiURL] = useState("");
    const [responseData, setResponseData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [apiKey, setApiKey] = useState('KEY_676bf947da1f4$2y$12$oqGxttvG1k6Ocaq7VWI8huUyhURahhno6RdwMDpBwDJ9xRBmJ4sy.'); // Default API key

    const fetchAPI = async () => {
        setLoading(true);
        setError(null);
        setResponseData(null);
        try {
            const response = await axios.get(apiURL, {
                headers: {
                    'APIKEY': apiKey,
                },
            });
            setResponseData(response.data['data']);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container p-6 mx-auto">
            <h1 className="mb-4 text-2xl font-bold">Test API Page</h1>
            <div className="mb-4">
                <label htmlFor="apiURL" className="block text-sm font-medium text-gray-700">
                    API URL:
                </label>
                <input
                    type="text"
                    id="apiURL"
                    value={apiURL}
                    onChange={(e) => setApiURL(e.target.value)}
                    placeholder="Enter API URL"
                    className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
            </div>
            <div className="mb-4">
                <label htmlFor="apiKey" className="block text-sm font-medium text-gray-700">
                    API Key:
                </label>
                <input
                    type="text"
                    id="apiKey"
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                    placeholder="Enter API Key"
                    className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
            </div>
            <button
                onClick={fetchAPI}
                className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                disabled={loading}
            >
                {loading ? "Loading..." : "Fetch API"}
            </button>

            <div className="mt-6">
                <h2 className="text-xl font-semibold">Response:</h2>
                {loading && <p>Loading...</p>}
                {error && <p className="text-red-500">Error: {error}</p>}
                {responseData && (
                    <pre className="overflow-auto p-4 bg-gray-100 rounded-md">
                        {JSON.stringify(responseData, null, 2)}
                    </pre>
                )}
            </div>
        </div>
    );
}

export default TestAPI;
